import React from 'react';
import { Switch, Route } from 'react-router-dom';
import styled from 'styled-components';

import Betting from './apps/Betting';
import Fantasy from './apps/Fantasy';
import Portal from './Portal';
import AccountRouteHandler from './Account/AccountRouteHandler';
import NotFound from './components/NotFound';
import usePortalPostMessage from './hooks/usePortalPostMessage';
import appConfig from './appConfig';

const AppRouter: React.FC = () => (
	<>
		{/* We need to leave client apps always mounted to let them clearing up effects when unmounted */}
		<Betting />
		{appConfig.fantasy.enabled && <Fantasy />}
		<Switch>
			<Route path="/betting" />
			{appConfig.fantasy.enabled && <Route path="/fantasy" />}
			<Route path="/account">
				<AccountRouteHandler />
			</Route>
			{/* <Route path="/prosper">
				<ProsperIntegration />
			</Route> */}
			<Route path="/" exact>
				<Portal />
			</Route>
			<Route>
				<NotFound />
			</Route>
		</Switch>
	</>
);

export default AppRouter;

const ProsperIntegration = () => {
	usePortalPostMessage();

	return (
		<div>
			<Frame src="https://dev-playup.prosper.games" title="prosper" id="prosper" />
		</div>
	);
};

const Frame = styled.iframe`
	width: 100%;
	height: 100vh;
`;
